import PreenchimentoClientePage from "./PreenchimentoClientePage";
import { useSelector } from "react-redux";
import {
  getPreenchimentoCliente,
  isCarregandoPreenchimentoCliente,
} from "../../../selectors/clientes.selectors";

const PreenchimentoClientePageConnected = () => {
  const loading = useSelector(isCarregandoPreenchimentoCliente);
  const data = useSelector(getPreenchimentoCliente);

  return <PreenchimentoClientePage loading={loading} cliente={data?.cliente} />;
};

export default PreenchimentoClientePageConnected;
